<template>
  <b-row>
    <b-col class="mb-2">
      <label>{{$t('views.excmdevicestate.list.table.date') + ' '
      + $t('global.smFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmdevicestate.list.table.date') + ' '
                                  + $t('global.smFrom')"
                            v-model.lazy="filters['readDate[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-col>
    <b-col class="mb-2">
      <label>{{$t('views.excmdevicestate.list.table.date')  + ' '
      + $t('global.smTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmdevicestate.list.table.date')  + ' '
                                  + $t('global.smTo')"
                            v-model.lazy="filters['readDate[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-col>
    <b-col cols="12" v-if="!idDevice">
      <b-row>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevice.list.filters.idDeviceType') }}:</label>
            <el-select
              class="select-default"
              v-model="filters.idDeviceType"
              multiple
              filterable
              @input="getDeviceModels"
              placeholder="">
              <el-option
                v-for="item in deviceTypes"
                :key="item['@id']"
                :label="item.title"
                :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevice.list.filters.idDeviceBrand') }}:</label>
            <el-select
              class="select-default"
              v-model="filters.idDeviceBrand"
              multiple
              filterable
              @input="getDeviceModels"
              placeholder="">
              <el-option
                v-for="item in deviceBrands"
                :key="item['@id']"
                :label="item.brandTitle"
                :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevice.show.model') }}:</label>
            <el-select
              class="select-default"
              v-model="filters.idDeviceModel"
              multiple
              filterable
              placeholder="">
              <el-option
                v-for="item in deviceModels"
                :key="item['@id']"
                :label="item.model"
                :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevice.list.filters.serialNumber') }}:</label>
            <input v-model.lazy="filters.serialNumber" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="3">
          <b-form-group>
            <label>{{ $t('views.excmcase.form.contractorUserData') }}</label>
            <base-select-input
              v-model="filters.idContractorUserData"
              :search-callback="contractorSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmnote.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="yesAndNoOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
export default {
  name: 'DeviceStateFiltering',
  components: { BaseSelectInput, VueCtkDateTimePicker },
  props: {
    getPage: {
      type: Function,
      required: true
    },
    idDevice: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      radioOptions: [
        {
          value: false,
          text: this.$t('buttons.no')
        },
        {
          value: true,
          text: this.$t('buttons.yes')
        }
      ],
      yesAndNoOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        serialNumber: '',
        'readDate[after]': '',
        'readDate[before]': '',
        idContractorUserData: '',
        idDeviceBrand: [],
        idDeviceType: [],
        idDeviceModel: [],
        state: 1
      },
      filtersReference: {},
      deviceBrands: [],
      deviceTypes: [],
      deviceModels: [],
      deviceContractors: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.filter()
      }
    }
  },

  created () {
    this.filtersReference = Object.assign({}, this.filters)
    this.getDeviceBrands()
    this.getDeviceTypes()
    this.getDeviceModels()
  },

  methods: {
    filter () {
      let url = 'e_x_c_m_device_states?_page=1'
      url += '&idDevice.state=' + this.filters.state
      if (this.filters.serialNumber) {
        url += '&idDevice.serialNumber=' + this.filters.serialNumber
      }
      if (this.filters['readDate[after]']) {
        url += '&readDate[after]=' + this.filters['readDate[after]']
      }
      if (this.filters['readDate[before]']) {
        url += '&readDate[before]=' + this.filters['readDate[before]']
      }
      if (this.filters.idDeviceBrand.length > 0) {
        for (let i in this.filters.idDeviceBrand) {
          url += '&idDevice.idDeviceModel.idDeviceBrand[]=' + this.getIdLink(this.filters.idDeviceBrand[i])
        }
      }
      if (this.filters.idDeviceType.length > 0) {
        for (let i in this.filters.idDeviceType) {
          url += '&idDevice.idDeviceModel.idDeviceType[]=' + this.getIdLink(this.filters.idDeviceType[i])
        }
      }
      if (this.filters.idDeviceModel.length > 0) {
        for (let i in this.filters.idDeviceModel) {
          url += '&idDevice.idDeviceModel[]=' + this.getIdLink(this.filters.idDeviceModel[i])
        }
      }
      if (this.filters.idContractorUserData) {
        url += '&idDevice.idContractorUserData=' + this.getIdLink(this.filters.idContractorUserData)
      }
      if (this.filters.deviceLocalization) {
        url += '&idDevice.deviceLocalization=' + this.getIdLink(this.filters.deviceLocalization)
      }
      this.getPage(url)
    },
    async getDeviceTypes () {
      let params = {
        'pagination': false,
        'state': 1,
        'order[title]': 'ASC'
      }
      this.deviceTypes = []
      const response = await new ApiService('e_x_c_m_device_types', params).getResults()
      this.deviceTypes = response.items
    },
    async getDeviceBrands () {
      let params = {
        pagination: false,
        state: 1,
        'order[brandTitle]': 'ASC'
      }
      this.deviceBrands = []
      const response = await new ApiService('e_x_c_m_device_brands', params).getResults()
      this.deviceBrands = response.items
    },
    async getDeviceModels () {
      let url = 'e_x_c_m_device_models?pagination=false&state=1&order[model]=ASC'
      if (this.filters.idDeviceBrand.length > 0) {
        for (let i in this.filters.idDeviceBrand) {
          url += '&idDeviceBrand[]=' + this.getIdLink(this.filters.idDeviceBrand[i])
        }
      }
      if (this.filters.idDeviceType.length > 0) {
        for (let i in this.filters.idDeviceType) {
          url += '&idDeviceType[]=' + this.getIdLink(this.filters.idDeviceType[i])
        }
      }
      const response = await new ApiService(url, {}).getResults()
      this.deviceModels = response.items
      let newDeviceModelFilter = JSON.parse(JSON.stringify(this.filters.idDeviceModel))
      for (let i in newDeviceModelFilter) {
        if (!this.deviceModels.map(entry => { return entry['@id'] }).includes(newDeviceModelFilter[i])) {
          newDeviceModelFilter.splice(i, 1)
        }
      }
      if (JSON.stringify(newDeviceModelFilter) !== JSON.stringify(this.filters.idDeviceModel)) {
        this.filters.idDeviceModel = newDeviceModelFilter
      }
    },
    async contractorSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    clearFilters () {
      this.filters = Object.assign({}, this.filtersReference)
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
